export default __webpack_public_path__ + "static/media/grady-luyt.7a807688.jpg";